// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","basketTab":"_3dB4GPstSECogQ7o","basketText":"_2hXwngu87CKaMAQ1","basketCount":"BCvfDOL6zUFc4Vmn","basketCountB2b":"_1BHUQM-PEpH5kUni"};